module.exports = __webpack_public_path__ + "img/borderCircularRightTopWhite.3688a6e9.svg";